import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, notification, Spin, Modal, Form, Input, DatePicker, Space, Flex, Checkbox, Select, Tabs } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import gearVuLogo from '../../assets/report/gearvu-logo.png';
// import './PromoCodeManagement.css';
import errorSound from '../../assets/sounds/error-sound.mp3';
import Sidebar from '../Sidebar/Sidebar';
import PromoCodeReportTable from './PromoCodeReportTable';
import moment from 'moment';
import CouponsTable from './couponsTable';
const { TabPane } = Tabs;
function PromoCodeManagement() {
  const [promoCodes, setPromoCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [couponsWithoutPromo, setCouponsWithoutPromo] = useState([]);
  const [products, setProducts] = useState([]);
  const [activeKey, setActiveKey] = useState("1");
  const playErrorSound = () => {
    const audio = new Audio(errorSound);
    audio.play();
  };

  // Fetch all promo codes on component mount
  useEffect(() => {
    fetchPromoCodes();
    fetchCoupons();
    fetchProducts();
  }, []);

  const normalizePromoCodes = (promos) => {
    return promos.map((promo) => {
      const coupon = promo.coupon || {};
      return {
        promoId: promo.id,
        name: coupon.name || 'Unnamed Coupon',
        key: coupon.id,
        code: promo.code,
        discountAmount: coupon.percent_off || coupon.amount_off || 0,
        discountType: coupon.percent_off ? 'percentage' : 'fixed',
        expirationDate: promo.expires_at
          ? moment.unix(promo.expires_at).toISOString()
          : null,
        active: promo.active,
        usedCount: promo.times_redeemed || 0,
        createdAt: moment.unix(promo.created).toISOString(),
        description: coupon.name || 'No description',
      };
    });
  };

  const fetchPromoCodes = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/promo/list');
      const rawPromos = response.data || [];
      const normalized = normalizePromoCodes(rawPromos);
      setPromoCodes(normalized);
    } catch (error) {
      console.error('Error fetching promo codes:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to load promo codes. Please try again later.',
        placement: 'topRight',
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/products/list');
      const rawPromos = response.data || [];
      setProducts(rawPromos)
    } catch (error) {
      console.error('Error fetching promo codes:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to load promo codes. Please try again later.',
        placement: 'topRight',
      });
    } finally {
      setLoading(false);
    }
  };
  const fetchCoupons = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/coupons/list');
      const rawPromos = response.data || [];
      setCouponsWithoutPromo(rawPromos)
    } catch (error) {
      console.error('Error fetching promo codes:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to load promo codes. Please try again later.',
        placement: 'topRight',
      });
    } finally {
      setLoading(false);
    }
  };


  // Deactivate promo code function for the table component

  // Table columns configuration - removed since we're using the report table component
  const items = [
    {
      key: "1",
      label: (
        <div
          style={{
            backgroundColor: activeKey === "1" ? "rgb(206, 46, 40)" : "transparent",
            color: activeKey === "1" ? "white" : "black",
            padding: "6px 12px",
            borderRadius: "6px",
            border: "1px solid rgb(206, 46, 40)",
            outline: 'none',
            borderBottom: '0.5 px solid  rgb(206, 46, 40)'
          }}
        >
          Promo Codes
        </div>
      ),
      children: <PromoCodeReportTable
        data={promoCodes}
        isToView={true}
        couponsWithoutPromo={couponsWithoutPromo}
        fetchPromoCodes={fetchPromoCodes}
      />,
    },
    {
      key: "2",
      label: (
        <div
          style={{
            backgroundColor: activeKey === "2" ? "rgb(206, 46, 40)" : "transparent",
            color: activeKey === "2" ? "white" : "black",
            padding: "6px 12px",
            borderRadius: "6px",
            border: "1px solid rgb(206, 46, 40)",
            outline: 'none',
            borderBottom: '0.5 px solid  rgb(206, 46, 40)'
          }}
        >
          Coupon Campaigns
        </div>
      ),
      children: <CouponsTable
        coupons={couponsWithoutPromo}
        fetchCoupons={fetchCoupons}
        products={products}
      />,
    },
  ];
 
    const inlineTabStyles = `
    .promo-management-tabs .ant-tabs-ink-bar {
      background-color: rgb(206, 46, 40) !important;
    }
    
    .promo-management-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: rgb(206, 46, 40) !important;
    }
    
    .promo-management-tabs .ant-tabs-tab:hover .ant-tabs-tab-btn {
      color: rgb(206, 46, 40) !important;
    }
  `;

  return (
    <div className="App"  style={{ display: 'flex', paddingLeft:60 }}>
        <style>{inlineTabStyles}</style>
      <div className='imie-finder-sidebar'>
        <Sidebar />
      </div>

      <div className="imei-finder">
        {loading ? (
          <div className="loading-container">
            <Spin size="large" />
          </div>
        ) : (
          <>
            <div className='imei-finder-table'>
              <Tabs
                activeKey={activeKey}
                onChange={(key) => setActiveKey(key)}
                items={items}
                className="promo-management-tabs" // Add this className
              />
            </div>

            {/* <div className='imei-finder-table'>
              <PromoCodeReportTable
                data={promoCodes}
                isToView={true}
                couponsWithoutPromo={couponsWithoutPromo}
                fetchPromoCodes={fetchPromoCodes}
              />
            </div>

            <div className='imei-finder-table'>
              <CouponsTable
                coupons={couponsWithoutPromo}
                fetchCoupons={fetchCoupons}
              />
            </div> */}
          </>
        )}



      </div>
    </div>
  );
}

export default PromoCodeManagement;